import script from "./commonUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./commonUpload.vue?vue&type=script&setup=true&lang=js"

import "./commonUpload.vue?vue&type=style&index=0&id=75844fac&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75844fac"]])

export default __exports__